import { useTranslation } from 'react-i18next';
import './adventurecard.css';

export default function AdventureCard({ text, quiz, correctAnswer, className }) {
  const { t } = useTranslation();

  return (
    <div className={`adventure__card ${className}`}>
      {quiz && <p className="quiz__text-adventure">{t('staticPages.firstAidChild.tapCorrectAnswer')}</p>}
      {correctAnswer && <p className="correct">{t('staticPages.firstAidChild.correctLabel')}</p>}
      {quiz ? <p className="quiz">{text}</p> : <p className="adventure__text">{text}</p>}
    </div>
  );
}
